// extracted by mini-css-extract-plugin
export default {"loaderBox":"styles_loaderBox__jQt33","loader":"styles_loader__G3nMC"};